import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Select from "common-ui-components/components/select";
import PhoneInput from "common-ui-components/components/phone-input/PhoneInput";
import styles from "../SupportForm.module.css";
import { MAIL_TYPE, sendSupportMail, normalizePhone } from "../../api";

const ENDPOINT_OPTIONS = ["Under 100", "100 - 500", "500 - 1,000", "1,000+"];
const PREFERRED_TIME_OPTIONS = ["This week", "Next week", "Any Time"];

const Demo = forwardRef((_, ref) => {
  const formRef = useRef(null);

  const [fullName, setFullName] = useState("");
  const [workEmail, setWorkEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [endpointCount, setEndpointCount] = useState(ENDPOINT_OPTIONS[0]);
  const [preferredTime, setPreferredTime] = useState(PREFERRED_TIME_OPTIONS[0]);
  const [demoNotes, setDemoNotes] = useState("");

  const endpointActiveIndex = ENDPOINT_OPTIONS.findIndex(
    (o) => o === endpointCount,
  );
  const preferredTimeActiveIndex = PREFERRED_TIME_OPTIONS.findIndex(
    (o) => o === preferredTime,
  );

  useImperativeHandle(ref, () => ({
    submit: async () => {
      if (formRef.current && !formRef.current.reportValidity()) {
        return { success: false };
      }
      try {
        await sendSupportMail({
          mailType: MAIL_TYPE.REQUEST_DEMO,
          payload: {
            requestDemoDTO: {
              fullName,
              workEmail,
              phoneNumber: normalizePhone(phoneNumber),
              endpoints: endpointCount,
              preferredDate: preferredTime,
              featuresToCover: demoNotes,
            },
          },
        });
        return { success: true };
      } catch (err) {
        return { success: false, error: err.message };
      }
    },
  }));

  return (
    <form
      ref={formRef}
      className={styles.form}
      onSubmit={(e) => e.preventDefault()}
    >
      <div className={styles.field}>
        <label className={styles.label} htmlFor="demoFullName">
          Full name<span className={styles.required}>*</span>
        </label>
        <input
          id="demoFullName"
          className={styles.input}
          placeholder="Jack William"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          required
        />
      </div>

      <div className={styles.grid}>
        <div className={styles.field}>
          <label className={styles.label} htmlFor="demoWorkEmail">
            Work email<span className={styles.required}>*</span>
          </label>
          <input
            id="demoWorkEmail"
            type="email"
            className={styles.input}
            placeholder="jack@jaytech.com"
            value={workEmail}
            onChange={(e) => setWorkEmail(e.target.value)}
            required
          />
        </div>

        <PhoneInput
          id="demoPhoneNumber"
          label="Phone number"
          value={phoneNumber}
          onChange={setPhoneNumber}
          className={styles.input}
        />
      </div>

      <div className={styles.grid}>
        <div className={styles.field}>
          <label className={styles.label} htmlFor="demoEndpointCount">
            Number of endpoints
          </label>
          <Select
            options={ENDPOINT_OPTIONS}
            active={Math.max(endpointActiveIndex, 0)}
            onOptionSelect={(option) => setEndpointCount(option)}
            triggerProps={{ id: "demoEndpointCount", className: styles.select }}
          />
        </div>

        <div className={styles.field}>
          <label className={styles.label} htmlFor="demoPreferredTime">
            Preferred time
          </label>
          <Select
            options={PREFERRED_TIME_OPTIONS}
            active={Math.max(preferredTimeActiveIndex, 0)}
            onOptionSelect={(option) => setPreferredTime(option)}
            triggerProps={{ id: "demoPreferredTime", className: styles.select }}
          />
        </div>
      </div>

      <div className={styles.field}>
        <label className={styles.label} htmlFor="demoNotes">
          What would you like the demo to cover?
        </label>
        <textarea
          id="demoNotes"
          className={styles.textarea}
          placeholder="e.g. Application control, software license tracking, compliance reporting..."
          value={demoNotes}
          onChange={(e) => setDemoNotes(e.target.value)}
        />
      </div>
    </form>
  );
});

Demo.displayName = "Demo";
export default Demo;
